import { blue, grey } from "@mui/material/colors";

const lightColors = {
  primary: {
    main: "#FFFFFF",
  },
  secondary: {
    main: grey[900],
  },
  divider: grey[300],
  text: {
    primary: grey[900],
    secondary: grey[800],
  },
  header: {
    main: blue[500],
  },
};

const darkColors = {
  primary: grey,
  secondary: grey,
  divider: grey[700],
  background: {
    default: grey[900],
    paper: grey[900],
  },
  text: {
    primary: "#fff",
    secondary: grey[500],
  },
};

const lightTypography = {
  h1: {
    color: blue[900],
  },
  h2: {
    color: blue[900],
  },
  h3: {
    color: blue[900],
  },
  h4: {
    color: blue[900],
  },
  h5: {
    color: blue[900],
  },
  h6: {
    color: blue[900],
  },
};

const darkTypography = {
  h1: {
    color: blue[500],
  },
  h2: {
    color: blue[500],
  },
  h3: {
    color: blue[500],
  },
  h4: {
    color: blue[500],
  },
  h5: {
    color: blue[500],
  },
  h6: {
    color: blue[500],
  },
};

export { lightColors, darkColors, lightTypography, darkTypography };
